import { render } from "./DialogAddSection.vue?vue&type=template&id=b964c540"
import script from "./DialogAddSection.vue?vue&type=script&lang=js"
export * from "./DialogAddSection.vue?vue&type=script&lang=js"
script.render = render

export default script